import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { testimonials } from '../data/mock';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const { language, t } = useLanguage();

  return (
    <section className="py-24 bg-stone-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-400 font-medium text-sm uppercase tracking-wider">
            {language === 'en' ? 'Testimonials' : 'Témoignages'}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-4">
            {t.testimonials.title}
          </h2>
          <p className="text-stone-400 max-w-2xl mx-auto text-lg">
            {t.testimonials.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-stone-800/50 backdrop-blur-sm rounded-2xl p-6 border border-stone-700/50 hover:border-teal-500/30 transition-colors"
            >
              <Quote className="w-8 h-8 text-teal-500/30 mb-4" />
              
              <p className="text-stone-300 text-sm leading-relaxed mb-6">
                "{testimonial[language]}"
              </p>

              <div className="flex items-center gap-3">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-stone-700"
                />
                <div>
                  <h4 className="text-white font-medium text-sm">
                    {testimonial.name}
                  </h4>
                  <p className="text-stone-500 text-xs">{testimonial.country}</p>
                </div>
              </div>

              <div className="flex items-center gap-1 mt-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;